import { useEffect, useRef, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { trackPageView } from "../api";

export function Layout() {
  const [open, setOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const location = useLocation();
  const lastTracked = useRef("");
  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    if (page === lastTracked.current) return;
    lastTracked.current = page;
    void trackPageView(page).catch(() => undefined);
  }, [location.pathname, location.search]);
  useEffect(() => {
    const scrollToDestination = () => {
      if (location.hash) {
        const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        if (target) target.scrollIntoView({ block: "start" });
        return;
      }
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };
    const frame = window.requestAnimationFrame(scrollToDestination);
    const retry = window.setTimeout(scrollToDestination, 250);
    return () => { window.cancelAnimationFrame(frame); window.clearTimeout(retry); };
  }, [location.key, location.pathname, location.search, location.hash]);
  return <>
    <a className="skip-link" href="#content">Skip to content</a>
    <header className="site-header">
      <Link className="brand brand-logo" to="/" onClick={() => setOpen(false)} aria-label="Saleh’s Plate home"><img src="/images/brand/salehs-plate-logo.png" alt=""/><span className="brand-name"><span className="brand-salehs">Saleh’s</span> Plate<small>By Saleh Alkhalifa</small></span></Link>
      <button className={`menu-button${open ? " open" : ""}`} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="site-nav" onClick={() => setOpen(!open)}><span/><span/><span/></button>
      <nav id="site-nav" className={open ? "open" : ""} aria-label="Primary">
        <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
        <NavLink to="/recipes" onClick={() => setOpen(false)}>Recipes</NavLink>
        <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
        <NavLink to="/suggest" onClick={() => setOpen(false)}>Suggest a dish</NavLink>
        <a className="instagram-link" href="https://www.instagram.com/salehs.plate/" target="_blank" rel="noreferrer"><InstagramIcon/> Follow me on Instagram</a>
      </nav>
    </header>
    <aside className={`ai-notice${aiOpen ? " open" : ""}`} aria-label="Responsible use of AI">
      <button type="button" aria-expanded={aiOpen} aria-controls="ai-notice-copy" onClick={() => setAiOpen(!aiOpen)}>
        <span><b>AI is used only for illustrations.</b> Recipes and real food photographs are human-made. <u>Read our Responsible AI policy.</u></span>
        <i aria-hidden="true">⌄</i>
      </button>
      <div id="ai-notice-copy">
        <p>Every recipe and every photograph of a finished dish is created by people. AI is used only for the artwork labeled “Illustrative Rendering,” which helps visualize a dish without replacing the cook or the real plate. <Link to="/privacy#ai" onClick={() => setAiOpen(false)}>Read our Responsible AI policy</Link></p>
      </div>
    </aside>
    <main id="content"><Outlet /></main>
    <footer><div><Link className="brand footer-brand brand-logo" to="/" aria-label="Saleh’s Plate home"><img src="/images/brand/salehs-plate-logo.png" alt=""/><span className="brand-name"><span className="brand-salehs">Saleh’s</span> Plate</span></Link><p>A personal cookbook by Saleh Alkhalifa.</p><small>© {new Date().getFullYear()} Recursiv LLC. Recipe text and Saleh-owned photographs are available under CC BY 4.0.</small></div><div><Link to="/recipes">Browse recipes</Link><Link to="/suggest">Suggest a dish</Link><Link to="/privacy">Privacy &amp; sharing terms</Link><Link to="/license">Reuse &amp; licensing</Link><a href="/feed.xml">RSS feed</a><a className="instagram-link" href="https://www.instagram.com/salehs.plate/"><InstagramIcon/> Follow me on Instagram</a></div></footer>
  </>;
}

export function InstagramIcon() {
  return <svg aria-hidden="true" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" className="instagram-dot"/></svg>;
}
